// store.js

import { createStore } from 'redux';
import controlPopupReducer from './controlPopupReducer';

const store = createStore(controlPopupReducer);

export default store;
